
import React from "react";
import { GuideSidebar } from "@/components/guide/GuideSidebar";
import { GuideContent } from "@/components/guide/GuideContent";
import { useGuideContent } from "@/hooks/useGuideContent";

const UserGuide: React.FC = () => {
  const {
    searchQuery,
    setSearchQuery,
    activeSection,
    setActiveSection,
    expandedSections,
    setExpandedSections,
    filteredContent
  } = useGuideContent();

  return (
    <div className="flex h-full min-h-screen bg-white">
      <GuideSidebar
        searchQuery={searchQuery}
        onSearchChange={(e) => setSearchQuery(e.target.value)}
        filteredContent={filteredContent}
        activeSection={activeSection}
        onSectionChange={setActiveSection}
        setExpandedSections={setExpandedSections}
      />
      <GuideContent
        filteredContent={filteredContent}
        activeSection={activeSection}
        expandedSections={expandedSections}
        searchQuery={searchQuery}
      />
    </div>
  );
};

export default UserGuide;
